var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('password-field',_vm._b({attrs:{"label":_vm.$t('Password')},model:{value:(_vm.password),callback:function ($$v) {_vm.password=$$v},expression:"password"}},'password-field',_vm.$attrs,false))}
var staticRenderFns = []

export { render, staticRenderFns }